import useSiteStore from '../stores/site.store'

// Site-related constants
// Note: This is a temporary hardcoded site ID for development.
// In production, this should be retrieved from user context/session.
export const CURRENT_SITE_ID = 'ccfdc896-e6d9-4b15-91ac-27878379cedc'

// Site fallback ID for hooks and components that need a default
export const FALLBACK_SITE_ID = CURRENT_SITE_ID

/**
 * Gets the current site ID from the site store.
 *
 * FOR FRONTEND USE ONLY - Do not use in backend/server code.
 *
 * Gets the site ID from the Zustand site store, which is synced with:
 * - URL query parameters (siteId)
 * - Location selection state
 * - User context/session
 *
 * @returns {string | null} The current site ID, or null if no site is selected
 */

export const getCurrentSiteId = () => {
  try {
    const currentSite = useSiteStore.getState().currentSite
    return currentSite?.siteId || null
  } catch {
    return null
  }
}
